import {h} from 'preact';
import { Input, Radio } from 'antd';
import fieldConfig from "./fieldConfig.js";

const FlowSettings = ({ formData, setFormData }) => {
    const handleInputChange = (field, value) => {
        setFormData(prevData => ({
            ...prevData,
            [field]: value
        }));
    };

    return (
        <div>
            <h3>General Flow Settings</h3>

            {fieldConfig.map(field => (
                <div key={field.id} style={{ marginBottom: field.marginBottom }}>
                    <h4>{field.label}</h4>

                    {field.type === 'input' && (
                        <Input
                            placeholder={field.placeholder}
                            value={formData[field.id]}
                            required={field.required}
                            onChange={(e) => handleInputChange(field.id, e.target.value)}
                        />
                    )}

                    {field.type === 'radio' && (
                        <Radio.Group
                            value={formData[field.id]}
                            onChange={(e) => handleInputChange(field.id, e.target.value)}
                        >
                            {field.options.map(option => (
                                <Radio key={option.value} value={option.value}>{option.label}</Radio>
                            ))}
                        </Radio.Group>
                    )}
                </div>
            ))}
        </div>
    );
};

export default FlowSettings;